import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/atoms'
import { useGlobalModalStore } from '@/stores/useGlobalModalStore/useGlobalModalStore'
import useNavigationGuardStore from '@/stores/useNavigationGuardStore/useNavigationGuardStore'

export const ExitReportCustomizationContent: React.FC = () => {
    const { t } = useTranslation('translations')

    const setModalState = useGlobalModalStore((state) => state.setModalState)
    const clearNavigationIntent = useNavigationGuardStore(
        (state) => state.clearNavigationIntent
    )

    const closeModal = useCallback(() => {
        setModalState({ isOpen: false })
    }, [setModalState])

    const onNavigationConfirmHandler = useNavigationGuardStore(
        (state) => state.onNavigationConfirmHandler
    )

    const setUnsavedChanges = useNavigationGuardStore(
        (state) => state.setUnsavedChanges
    )

    const onSubmit = useCallback(() => {
        setUnsavedChanges(false)
        onNavigationConfirmHandler?.()
        clearNavigationIntent()
        closeModal()
    }, [
        clearNavigationIntent,
        closeModal,
        onNavigationConfirmHandler,
        setUnsavedChanges,
    ])

    return (
        <div className="text-sm">
            <div className="flex flex-row-reverse gap-4 border-t border-t-neutral-200 px-6 py-4">
                <Button
                    name="delete"
                    variant={'solidPrimaryDestructive'}
                    size="large"
                    onClick={() => {
                        onSubmit()
                    }}
                    className="whitespace-nowrap"
                    data-testid="confirm-navigation-button"
                >
                    {t('reporting.exit_customization.submit_button')}
                </Button>
                <Button
                    name="cancel"
                    variant={'outlinePrimary'}
                    size="large"
                    onClick={() => {
                        closeModal()
                    }}
                    className="whitespace-nowrap"
                    data-testid="cancel-navigation-button"
                >
                    {t('reporting.exit_customization.cancel_button')}
                </Button>
            </div>
        </div>
    )
}
